import { ceilGyps } from "./ceilGyps.js";
import { ceilTbar } from "./ceilTbar.js";
import { floorTile } from "./floorTile.js";
import { genericFormula } from "./generic.js";
import type { MaterialFormula, MaterialRate } from "./types.js";

/** category_id ทั้ง 22 หมวดใน category_master */
export const CATEGORY_IDS = [
  "PAINT", "ELEC", "PLUMB", "STRUCT_01", "CEIL_TBAR", "CEIL_GYPS", "WALL_BRICK", "FLOOR_TILE",
  "HVAC", "WATERP", "DEMO", "CEIL_GEN", "WALL_LIGHT", "FLOOR_GEN", "ROOF", "STEEL", "ALUM_GL",
  "CARP", "SITE", "LAND", "FIRE", "ELEV",
] as const;
export type CategoryId = (typeof CATEGORY_IDS)[number];

const formulas = new Map<string, MaterialFormula>([
  ["CEIL_TBAR", ceilTbar],
  ["CEIL_GYPS", ceilGyps],
  ["FLOOR_TILE", floorTile],
]);

/** สูตรทั่วไปสำหรับหมวดที่ยังไม่มีอัตราใน material_components คืนรายการว่าง */
const noMaterials: MaterialFormula = genericFormula([]);

/** ลงทะเบียนสูตรเฉพาะหมวด (ทับของเดิมได้) */
export function registerFormula(categoryId: string, formula: MaterialFormula): void {
  formulas.set(categoryId, formula);
}

/** ลงทะเบียนสูตรทั่วไปจากตารางอัตราต่อ ตร.ม. */
export function registerRates(categoryId: string, rates: readonly MaterialRate[]): void {
  formulas.set(categoryId, genericFormula(rates));
}

/** คืนสูตรของหมวด ถ้าไม่มีสูตรเฉพาะจะคืนสูตรทั่วไป (ไม่มีอัตา = รายการว่าง) */
export function getFormula(categoryId: string): MaterialFormula {
  return formulas.get(categoryId) ?? noMaterials;
}

export function hasSpecificFormula(categoryId: string): boolean {
  return formulas.has(categoryId);
}
